(function () {
  function initBonsBrandHeader() {
    var header = document.querySelector('[data-bons-brand-header]');

    if (!header || header.dataset.bonsInitialized === 'true') {
      return;
    }

    var toggle = header.querySelector('[data-bons-menu-toggle]');
    var menu = header.querySelector('[data-bons-mobile-menu]');

    if (!toggle || !menu) {
      return;
    }

    header.dataset.bonsInitialized = 'true';

    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBonsBrandHeader);
  } else {
    initBonsBrandHeader();
  }

  document.addEventListener('shopify:section:load', initBonsBrandHeader);
})();
